import styled from "styled-components";
import { visuallyHidden } from "@m/alchemy-theme";
export const ScreenReaderContent = styled.span `
  ${visuallyHidden()};
`;
// Better alias name that matches the helper name
export const VisuallyHidden = ScreenReaderContent;
